import React from "react";
import sessionProvider from "./../../../../shared/utils/session";
import { Redirect, Route } from "react-router";

export const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const session = sessionProvider.create(sessionStorage);
  const toRedirectLogin = {
    pathname: "/Login",
    state: {
      from: rest.location
    }
  };

  const renderComponent = props => {
    let hasToken = session.getToken();
    let hasSessionData = session.getUserData() && session.getUserData().Contexto;

    let hasAllData = hasToken && hasSessionData;

    if (hasAllData) {
      return <Component {...props} />;
    }

    if (!hasToken) {
      return <Redirect to={toRedirectLogin} />;
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={renderComponent} />;
};

export const PublicRoute = ({ component: Component, ...rest }) => {
  const renderComponent = props => {
    return <Component {...props} />;
  };

  return <Route {...rest} render={renderComponent} />;
};
